<div class="fw-Navigation_Icons">
	<a class="fw-Navigation-trade" *ngIf="!isPreLogin && !isDisclosurePage && isTradeEntitled" href="javascript:void(0);" (click)="navigateToUrl()">
		<div class="fw-Navigation-tradeIcon" matTooltip="{{ 'ICONS_TOOLTIP.TRADE' | translate}}"></div>
		<span class="fw-Navigation-tradeText">{{ 'ICONS_TOOLTIP.TRADE' | translate}}</span>
	</a>
	<a class="fw-Navigation-transfer" *ngIf="!isPreLogin && !isDisclosurePage && isTransferEntitled" href="javascript:void(0);" (click)="redirectRoute('/nxi/transact/fundstransfer')">
		<div class="fw-Navigation-transferIcon" matTooltip="{{ 'ICONS_TOOLTIP.TRANSFER' | translate}}"></div>
		<span class="fw-Navigation-transferText">{{ 'ICONS_TOOLTIP.TRANSFER' | translate}}</span>
	</a>
	<a class="fw-Navigation-paybill" *ngIf="!isPreLogin && !isDisclosurePage && isPayBillsEntitled" href="javascript:void(0);" (click)="redirectRoute('/nxi/transact/paybills')">
		<div class="fw-Navigation-paybillIcon" matTooltip="{{ 'ICONS_TOOLTIP.PAYBILLS' | translate}}"></div>
		<span class="fw-Navigation-paybillText">{{ 'ICONS_TOOLTIP.PAYBILLS' | translate}}</span>
	</a>
</div>